import { useRef, useState } from "react";
import styled from "styled-components";
import { injectIntl } from "react-intl";
import Swiper from "react-id-swiper";

import { connectComponent } from "../../../store/store.js";

import Picture from "../../Picture/Picture.js";
import Figcaption from "../Figcaption.js";
import { Next, Prev } from '../../NextPrev.js';

const Container = styled.div`
	width: 100%;
	margin-bottom: 3.75em;
`;

const SlideWrapper = styled.div``;

const ImageWrapper = styled.figure`
	width: 80vw;
	height: 80vh;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	flex-direction: column;
	margin: 0;
`;

const StyledPicture = styled(Picture)`
	width: 100%;
	height: 100%;
	position: relative;
	background: transparent;
`;



// http://idangero.us/swiper
// http://idangero.us/swiper/demos/240-effect-coverflow.html
// https://github.com/nolimits4web/Swiper/blob/master/demos/250-effect-flip.html/

const Gallery = ({ children, setCurrentTooltip, intl, isLightboxAvailable, setLightboxIndex, lightboxIndex }) => {
	if (!children) return null;
	const sliderEl = useRef(null);
	const [isInit, setIsInit] = useState(false);
	const [wasInteracted, setWasInteracted] = useState(false);
	const uuid = useRef(Math.round(Math.random() * 99999));

	const destroy = () => {
		setCurrentTooltip(null);
	};

	const swiperOptions = {
		effect: "coverflow",
		grabCursor: true,
		centeredSlides: true,
		slidesPerView: "auto",
		keyboard: true,
		coverflowEffect: {
			rotate: 40,
			stretch: 0,
			depth: 100,
			modifier: 1,
			slideShadows: false,
		},
		on: {
			touchMove: () => {
				setWasInteracted(true);
				setCurrentTooltip(null);
			},
		},
		navigation: {
      nextEl: `#gallery-${uuid.current}__button--next`,
      prevEl: `#gallery-${uuid.current}__button--prev`,
    },
    renderPrevButton: () => (
      <Next id={`gallery-${uuid.current}__button--next`}>
        <svg
          width="47"
          height="47"
          viewBox="0 0 47 47"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <polygon
              points="23.482441 0 46.9648821 23.482441 23.482441 46.9648821 19.3627145 42.8451556 35.7042963 26.3662496 0 26.3662496 0 20.5986325 35.7042963 20.5986325 19.3627145 4.1197265"
              fill="#000"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Next>
    ),
    renderNextButton: () => (
      <Prev id={`gallery-${uuid.current}__button--prev`}>
        <svg
          width="47"
          height="47"
          viewBox="0 0 47 47"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <polygon
              transform="matrix(-1 0 0 1 47.035 0)"
              points="23.5175591 0 47.0000001 23.482441 23.5175591 46.9648821 19.3978326 42.8451556 35.7394143 26.3662496 0.035118 26.3662496 0.035118 20.5986325 35.7394143 20.5986325 19.3978326 4.1197265"
              fill="#000"
              fillRule="nonzero"
            />
          </g>
        </svg>
      </Prev>
    )
	};

	return (
		<Container
			key={uuid.current}
			data-id={uuid.current}
			ref={sliderEl}
			className="swiper-container"
			onMouseEnter={() => {
				if (wasInteracted) return;
				setCurrentTooltip(intl.formatMessage({ id: "drag" }));
			}}
			onMouseLeave={() => {
				setCurrentTooltip(null);
			}}
		>
			<Swiper { ...swiperOptions }>
				{children.map(({ image, caption, credit, altText }, i) => (
					<ImageWrapper key={i} isVisible={isInit} className="swiper-slide">
						<StyledPicture
							isLightboxAvailable={isLightboxAvailable}
							onClick={isLightboxAvailable ? () => setLightboxIndex(lightboxIndex + i) : null}
							fit="contain"
							sizes="90vw"
							key={i}
							alt={altText || caption}
							{...image[0]}
						/>
						<Figcaption credit={credit} caption={caption} />
					</ImageWrapper>
				))}
			</Swiper>
			{/* SWIPER STYLES ARE BEING INCLUDED AS STATIC IMPORT */}
		</Container>
	);
};
export default injectIntl(connectComponent(Gallery, []));
